import { HttpHelper, HttpServiceParams } from '@ppvrbh/merchant-frontend-core';
import { envConfig } from '../../../../config';
import { CAT_REQUEST_ID_LIST } from './cat-constant';

class CatServiceClass {
  getCat = async (params: HttpServiceParams) => {
    const searchParams = new URLSearchParams();
    if (params.data?.menuCount) {
      searchParams.append('menuCount', params.data.menuCount);
    }
    if (params.data?.menuCategoryCount) {
      searchParams.append('menuCategoryCount', params.data.menuCategoryCount);
    }
    if (params.data?.keyword) {
      searchParams.append('keyword', params.data.keyword)
    }
    if (params.data?.page) {
      searchParams.append('page', params.data.page)
    }
    if (params.data?.limit) {
      searchParams.append('limit', params.data.limit)
    }

    const paramString = searchParams.toString();
    let query = '';
    if (paramString) {
      query = '?' + paramString
    }
    return await HttpHelper.get({
      url: envConfig.hostname + 'v1/merchant/company-admin/menu-categories' + query,
      id: CAT_REQUEST_ID_LIST.GET_CAT
    });
  }

  postCat = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: envConfig.hostname + 'v1/merchant/company-admin/menu-categories',
      data: params.data,
      id: CAT_REQUEST_ID_LIST.POST_CAT
    });
  }

  patchCat = async (params: HttpServiceParams) => {
    return await HttpHelper.patch({
      url: envConfig.hostname + 'v1/merchant/company-admin/menu-categories',
      data: params.data,
      id: CAT_REQUEST_ID_LIST.PATCH_CAT
    });
  }

  deleteCat = async (params: HttpServiceParams) => {
    return await HttpHelper.delete({
      url: envConfig.hostname + 'v1/merchant/company-admin/menu-categories',
      config: { headers: { menuCategoryId: params.data } },
      id: CAT_REQUEST_ID_LIST.DELETE_CAT
    });
  }

  updateCategorySequence = async (params: HttpServiceParams) => {
    return await HttpHelper.put({
      url: envConfig.hostname + 'v1/merchant/company-admin/menu-categories/sequences',
      data: {
        menuCategoryIds: params.data
      },
      id: CAT_REQUEST_ID_LIST.UPDATE_CATEGORY_SEQUENCE
    });
  }

  getMenuInCat = async (params: HttpServiceParams) => {
    return await HttpHelper.get({
      url: envConfig.hostname + 'v2/merchant/company-admin/menus/landing',
      config: {
        params: {
          menuCategoryId: params.data?.menuCategoryId,
          ...(params.data?.search && { search: params.data.search }),
          ...(params.data?.page && { page: params.data.page }),
          ...(params.data?.limit && { limit: params.data.limit }),
        },
      },
      id: CAT_REQUEST_ID_LIST.GET_MENU_IN_CAT
    });
  }

  sortMenuSequenceInCat = async (params: HttpServiceParams) => {
    return await HttpHelper.put({
      url: envConfig.hostname + 'v1/merchant/company-admin/menus/sequences',
      data: params.data,
      id: CAT_REQUEST_ID_LIST.SORT_MENU_SEQUENCE,
    });
  }
}

export const CatService = new CatServiceClass();
